import { mapState, mapGetters, mapActions } from 'vuex'
import { dragscroll } from 'vue-dragscroll'

import Icon from '@/components/icon'

export default {
  components: {
    appIcon: Icon
	},
	directives: {
    dragscroll
  },
	data () {
		return {
			photo: '',
			photoIndex: 0,
			distance: 0,
			opacity: 1,
			hideDuration: 350,
			showDuration: 150,
			threshold: 30,
			thresholdPhone: 5,
			bound: 50,
			isTransitionClass: true,
			isGrabbingClass: false
		}
	},
  computed: {
		...mapState('tours', ['photos']),
		...mapState('utils', ['widgets']),
		...mapGetters('tours', ['getPhotoByIndex']),
		selectedPhotoIndex () {
			return this.widgets.lightbox.photoIndex
		},
		show () {
			return this.widgets.lightbox.show
		}
  },
  methods: {
		...mapActions('utils', ['closeLightbox']),
		onDragMove (event) {
			this.updateDistance(this.distance - parseInt(event.detail.deltaX / 2))

			this.isGrabbingClass = true
		},
		onDragEnd () {
			if (this.distance > this.threshold) {
				this.prevPhoto()
			} else if (this.distance < -this.threshold) {
				this.nextPhoto()
			} else {
				this.updateDistance(0)
			}

			this.isGrabbingClass = false
		},
		onArrowsKeyUp (evt) {
			if (this.opacity !== 1) {
				return
			}

      switch (evt.code) {
        case 'ArrowLeft':
          this.onPrevious()
          break
        case 'ArrowRight':
          this.onNext()
					break
				case 'Escape':
          this.closeLightbox()
          break
      }
    },
		onPrevious () {
			this.updateDistance(this.bound)
			this.prevPhoto()
		},
		onNext () {
			this.updateDistance(-this.bound)
			this.nextPhoto()
		},
		prevPhoto () {
			if (this.photoIndex === 0) {
				this.photoIndex = this.photos.length - 1
			} else {
				this.photoIndex = --this.photoIndex
			}

			this.hidePhoto(-this.bound)
		},
		nextPhoto () {
			if (this.photoIndex === this.photos.length - 1) {
				this.photoIndex = 0
			} else {
				this.photoIndex = ++this.photoIndex
			}

			this.hidePhoto(this.bound)
		},
		hidePhoto (distance) {
			this.updateOpacity(0)

			setTimeout(() => {
				this.isTransitionClass = false

				this.updatePhoto()
				this.updateDistance(distance)
				this.showPhoto()
			}, this.hideDuration)
		},
		showPhoto () {
			setTimeout(() => {
				this.isTransitionClass = true

				this.updateDistance(0)
				this.updateOpacity(1)
			}, this.showDuration)
		},
		updateDistance (distance) {
			this.distance = distance
		},
		updateOpacity (opacity) {
			this.opacity = opacity
		},
		updatePhoto () {
			this.photo = this.getPhotoByIndex(this.photoIndex).urls[1].url
		},
		setThreshold () {
			const phoneViewport = window.matchMedia('screen and (max-width: 799px)');

			if(phoneViewport.matches) {
				this.threshold = this.thresholdPhone
			}
		},
    init () {
			this.photoIndex = this.selectedPhotoIndex

			this.updatePhoto()
			this.setThreshold()

			document.addEventListener('keyup', this.onArrowsKeyUp)
		},
		destroy () {
			document.removeEventListener('keyup', this.onArrowsKeyUp)
		}
	},
	watch: {
    show () {
			if (this.show) {
				this.init()
			} else {
				this.destroy()
			}
    }
  }
}
